/*
|--------------------------------------------------------------------------
| x-autosize: una caja de texto que crece con lo que se escribe
|--------------------------------------------------------------------------
|
| Nunca baja del alto de sus `rows`, y se puede seguir estirando a mano.
| Sustituye a @marcreichel/alpine-autosize (parado desde 2023), que para
| esto cargaba otra librería. Como aquel, con `wire:model` la caja lleva
| `wire:ignore`: si no, Livewire la vuelve a pintar y le quita el alto.
|
*/
export default function autosize(Alpine) {
    Alpine.directive("autosize", (el, directive, { cleanup }) => {
        const bound = el.getAttributeNames().some((name) => name === "wire:model" || name.startsWith("wire:model."));

        if (bound && !el.hasAttribute("wire:ignore")) {
            el.setAttribute("wire:ignore", "");
        }

        const update = () => {
            const style = getComputedStyle(el);
            const borders = style.boxSizing === "border-box"
                ? parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
                : 0;

            // Medir obliga a encoger la caja un instante: sin guardar el
            // scroll, la página saltaría hacia arriba al escribir al final.
            const scroller = document.scrollingElement;
            const scrollTop = scroller ? scroller.scrollTop : 0;

            el.style.height = "auto";
            el.style.height = `${el.scrollHeight + borders}px`;

            if (scroller) {
                scroller.scrollTop = scrollTop;
            }
        };

        el.addEventListener("input", update);
        el.addEventListener("autosize", update);
        window.addEventListener("resize", update);
        requestAnimationFrame(update);

        cleanup(() => {
            el.removeEventListener("input", update);
            el.removeEventListener("autosize", update);
            window.removeEventListener("resize", update);
            el.style.height = "";
        });
    });
}
